import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import RoadLine from "./RoadLine";

export const FinalCTA = () => (
    <section data-testid="final-cta-section" className="relative overflow-hidden bg-night py-24 md:py-32">
        <div className="pointer-events-none absolute inset-x-0 top-10 opacity-[0.06]" aria-hidden="true">
            <RoadLine light testId="final-cta-road-line-top" />
        </div>
        <div className="pointer-events-none absolute inset-x-0 bottom-10 opacity-[0.06]" aria-hidden="true">
            <RoadLine light testId="final-cta-road-line-bottom" />
        </div>
        <div className="relative mx-auto max-w-4xl px-5 sm:px-8 text-center">
            <Reveal>
                <h2 className="font-heading text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
                    Good companies move freight.{" "}
                    <span className="text-brand">Great companies take care of the people who move it.</span>
                </h2>
            </Reveal>
            <Reveal delay={0.12}>
                <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/70 md:text-lg">
                    Experience the difference of working with a family-owned trucking company built on
                    respect, communication, and relationships.
                </p>
            </Reveal>
            <Reveal delay={0.22}>
                <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
                    <Link
                        to="/drivers#apply"
                        data-testid="final-cta-drive-button"
                        className="w-full sm:w-auto rounded-md bg-brand px-8 py-4 font-heading text-base font-semibold text-night transition-[background-color,transform] duration-200 hover:bg-brand-dark hover:-translate-y-0.5"
                    >
                        Drive With Nightline
                    </Link>
                    <Link
                        to="/contact"
                        data-testid="final-cta-contact-button"
                        className="w-full sm:w-auto rounded-md border border-white/30 px-8 py-4 font-heading text-base font-semibold text-white transition-colors duration-200 hover:border-white hover:bg-white/5"
                    >
                        Contact Nightline
                    </Link>
                </div>
            </Reveal>
        </div>
    </section>
);

export default FinalCTA;
